/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs */

const en_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Plan Discount`)
};

const de_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Rabatt anwenden`)
};

const es_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar un descuento`)
};

const fr_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer une remise`)
};

const nl_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische abonnementskorting`)
};

const it_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica uno sconto`)
};

const pt_br2_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar desconto no plano`)
};

const pl_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zastosuj zniżkę na plan`)
};

const hu_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csomag kedvezmény alkalmazása`)
};

const ro_admin_plan_discount_form_apply_plan_discount = /** @type {(inputs: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicati reducere plan`)
};

/**
* | output |
* | --- |
* | "Automatic Plan Discount" |
*
* @param {Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_apply_plan_discount = /** @type {((inputs?: Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_Apply_Plan_DiscountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_apply_plan_discount(inputs)
	if (locale === "de") return de_admin_plan_discount_form_apply_plan_discount(inputs)
	if (locale === "es") return es_admin_plan_discount_form_apply_plan_discount(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_apply_plan_discount(inputs)
	if (locale === "nl") return nl_admin_plan_discount_form_apply_plan_discount(inputs)
	if (locale === "it") return it_admin_plan_discount_form_apply_plan_discount(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_apply_plan_discount(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_apply_plan_discount(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_apply_plan_discount(inputs)
	return ro_admin_plan_discount_form_apply_plan_discount(inputs)
});
export { admin_plan_discount_form_apply_plan_discount as "admin.plan_discount_form.apply_plan_discount" }